import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Injected after store creation to avoid circular imports
let _store;
export const injectStore = (s) => { _store = s; };

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid — clear session and let ProtectedRoute redirect
      _store?.dispatch({ type: "auth/logout" });
    }
    return Promise.reject(error);
  }
);

export const loginApi = (email, password) =>
  API.post("/auth/sales-login", { email, password });

export const validateApi = () =>
  API.get("/auth/validation");

// ================= VENDOR ONBOARDING =================
export const submitVendorOnboardingApi = (data) => API.post("/vendor/onboard", data);

// ================= DASHBOARD =================
export const getMyDashboardApi = () => API.get("/sales-person/me/dashboard");

// ================= FILE UPLOAD (S3) =================
export const uploadImageApi = (file, folder) => {
  const form = new FormData();
  form.append("file", file);
  form.append("folder", folder);
  return API.post("/api/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const deleteImageApi = (url) =>
  API.delete(`/api/upload?url=${encodeURIComponent(url)}`);
